const iconNames = [
  "fa-church fas",
  "fa-cross fas",
  "fa-baby far",
  "fa-heart fas",
  "fa-heart-square fas",
  "fa-bible far",
  "fa-dove far",
  "fa-fish far",
  "fa-sheep far",
  "fa-pray fas",
  "fa-praying-hands far",
  "fa-american-sign-language-interpreting fas",
  "fa-blind fas",
  "fa-deaf fas",
  "fa-bells fas",
  "fa-comment-alt-exclamation fas",
  "fa-address-card fas",
  "fa-angel fas",
  "fa-award fas",
  "fa-badge-check fas",
  "fa-book fas",
  "fa-bookmark fas",
  "fa-briefcase fas",
  "fa-building fas",
  "fa-fire far",
  "fa-bus fas",
  "fa-calendar far",
  "fa-calendar-star far",
  "fa-car fas",
  "fa-chalkboard-teacher fas",
  "fa-check-circle fas",
  "fa-cheeseburger fas",
  "fa-child far",
  "fa-clipboard-check fas",
  "fa-cloud fas",
  "fa-cloud-hail-mixed fas",
  "fa-coffee-togo far",
  "fa-cog fas",
  "fa-comment-alt fas",
  "fa-copy far",
  "fa-crown fas",
  "fa-desktop fas",
  "fa-dog fas",
  "fa-envelope-open-text far",
  "fa-eye fas",
  "fa-female fas",
  "fa-male fas",
  "fa-file far",
  "fa-flag fas",
  "fa-flower-tulip far",
  "fa-frown-open far",
  "fa-glass-martini-alt far",
  "fa-glasses fas",
  "fa-globe-americas far",
  "fa-grin-beam far",
  "fa-grin-tongue far",
  "fa-home-lg fas",
  "fa-landmark fas",
  "fa-laptop fas",
  "fa-leaf fas",
  "fa-lightbulb fas",
  "fa-link fas",
  "fa-lock-alt fas",
  "fa-map far",
  "fa-map-marked-alt fas",
  "fa-map-marker-alt fas",
  "fa-map-pin fas",
  "fa-mobile far",
  "fa-palette far",
  "fa-paper-plane fas",
  "fa-pencil-paintbrush far",
  "fa-pencil-ruler far",
  "fa-phone far",
  "fa-pizza-slice fas",
  "fa-plane-alt fas",
  "fa-podcast fas",
  "fa-podium fas",
  "fa-portrait far",
  "fa-restroom fas",
  "fa-rocket far",
  "fa-shopping-bag fas",
  "fa-signal-alt fas",
  "fa-sliders-h-square fas",
  "fa-star fas",
  "fa-sun fas",
  "fa-thumbs-up far",
  "fa-tombstone far",
  "fa-tree-christmas far",
  "fa-tshirt far",
  "fa-tv fas",
  "fa-user-friends fas",
  "fa-venus-mars fas",
  "fa-basketball-ball fas",
  "fa-city far",
  "fa-beer far",
  "fa-cloud-rainbow fas",
  "fa-birthday-cake fas",
  "fa-rings-wedding fas",
  "fa-graduation-cap far",
  "fa-map-marked fas",
  "fa-calendar fas",
  "fa-calculator fas",
  "fa-keyboard fas",
  "fa-ballot-check fas",
  "fa-upload fas",
];

export default iconNames;
